<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "DeathAndDisabilityBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "身故及完全失能保險金",
        pageBlock: ["periodMulti", "formulaMulti", "maxMulti"],
        showUpper: false,
        showHint: true,
        showCoverageItems: false,
      },
      defaultForm: {
        periodType: 7,
        max_period: "",
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        from.name === "MaintainForm8" ||
        from.name === "CreateForm903" ||
        from.name === "TerminationFeeAndReserveMaintain"
      ) {
        vm.pageControl.settingType = 2;
      }
    });
  },
  watch: {},
  methods: {
    init() {
      this.categoryList = [];
      this.isLoading = true;
      queryCoverageCategoryMain(this.$store.state.userInfo.id).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            result.data.forEach((item) => {
              let categoryData = {
                categoryId: item.coveragecategoryid,
                categoryNum: item.sequencenumber,
                categoryName: item.name,
                editMode: false,
              };
              this.categoryList.push(categoryData);
            });
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isLoading = false;
        }
      );
    },
    openEditMode(data) {
      this.isEdit = true;
      data.editMode = !data.editMode;
      data.originCategoryName = data.categoryName;
    },
    exitEditMode(data) {
      this.isEdit = false;
      data.editMode = !data.editMode;
      data.categoryName = data.originCategoryName;
    },
    removeCategory(data) {
      if (confirm("確認是否刪除！？")) {
        this.isLoading = true;
        deleteCoverageCategoryMain(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.init();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
          }
        );
      }
    },
    doEdit(data) {
      //檢核
      this.isCategoryNameExist = false;
      this.$validator.validateAll().then((el) => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        this.categoryList.forEach((item) => {
          if (
            data.categoryName != "" &&
            item.categoryName == data.categoryName &&
            item.categoryId != data.categoryId
          ) {
            this.isCategoryNameExist = true;
            this.$toast.info({ title: "給付歸類說明已存在" });
          }
        });
        if (this.isCategoryNameExist) {
          return;
        }
        //通過檢查

        this.isLoading = true;
        updateCoverageCategoryMain(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "編輯成功" });
              this.init();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
            this.isEdit = false;
          }
        );
      });
    },
  },
  mounted() {
    this.init();
  }
};
</script>